import { render } from "./RemovableServices.vue?vue&type=template&id=dc480a6e"
import script from "./RemovableServices.vue?vue&type=script&lang=js"
export * from "./RemovableServices.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__